import { Link } from "react-router-dom";
import { tutoringUrl } from "../lib/api";

// Global footer for public (unauthenticated) pages. Keeps low-priority nav
// like Pricing and Refund out of the top bar so the main nav can stay
// focused on learning CTAs, while still being discoverable.
export default function SiteFooter() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="mt-24 border-t border-[#E5E7E2] bg-[#F5F1E4]"
            data-testid="site-footer"
        >
            <div className="container-page py-10 flex flex-wrap gap-8 items-start justify-between">
                <div className="min-w-[220px] max-w-md">
                    <p className="font-medium text-[#1C2321] mb-1" style={{ fontFamily: "Outfit" }}>
                        Lift Up Reading
                    </p>
                    <p className="text-sm text-[#515B57] leading-relaxed">
                        Reading, for grown-ups. Free to use — reading is a right, not a privilege.
                    </p>
                </div>
                <nav
                    className="flex flex-wrap gap-x-8 gap-y-3 text-sm"
                    aria-label="Footer navigation"
                >
                    <Link
                        to="/pricing"
                        data-testid="footer-pricing"
                        className="text-[#515B57] hover:text-[#2D5D4E]"
                    >
                        Pricing
                    </Link>
                    <a
                        href={tutoringUrl("footer")}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-tutoring"
                        className="text-[#515B57] hover:text-[#D47A55]"
                    >
                        Tutoring ↗
                    </a>
                    <Link
                        to="/refund"
                        data-testid="footer-refund"
                        className="text-[#515B57] hover:text-[#2D5D4E]"
                    >
                        Refund policy
                    </Link>
                    <Link
                        to="/privacy"
                        data-testid="footer-privacy"
                        className="text-[#515B57] hover:text-[#2D5D4E]"
                    >
                        Privacy
                    </Link>
                    <Link
                        to="/terms"
                        data-testid="footer-terms"
                        className="text-[#515B57] hover:text-[#2D5D4E]"
                    >
                        Terms
                    </Link>
                    <Link
                        to="/login"
                        data-testid="footer-signin"
                        className="text-[#515B57] hover:text-[#2D5D4E]"
                    >
                        Sign in
                    </Link>
                </nav>
            </div>
            <div className="border-t border-[#E5E7E2] py-5">
                <p className="container-page text-xs text-[#819888] text-center">
                    © {year} Lift Up Reading.
                </p>
            </div>
        </footer>
    );
}
